import React from 'react';
import { statusTypes } from '../../../mls-match-list/utils';
import { culture } from '../../../shared/api/variables';
import { useReactAppState } from '../../../shared/containers/utils';
import { trackMatchInteraction } from '../../../../libraries/_modules/tracking/helpers';

function MatchCta({
  matchStatus,
  appleStreamURL,
  hasHighlights,
  highlightsUrl,
  matchPageUrl,
  slug,
  position,
  matchId,
  location,
  sponsor,
}) {
  const { t } = useReactAppState();
  const status = matchStatus?.abbreviation;

  const trackInteraction = (event, ctaAction) => {
    if (!event) return null;
    event.preventDefault();
    const { href, target } = event.currentTarget;

    trackMatchInteraction({
      event: 'cta_clicked',
      match: slug,
      cta_action: ctaAction,
      click_url: href,
      position,
      module_type: 'priority_match',
      match_id: matchId,
      location,
      sponsor,
    });

    window.open(href, target);
  };

  if (
    (status === statusTypes.pre || status === statusTypes.live) &&
    appleStreamURL
  ) {
    return (
      <a
        href={appleStreamURL}
        target="_blank"
        rel="noopener noreferrer"
        className="mls-c-priority-match__cta mls-c-priority-match__cta--watch"
        onClick={(e) =>
          trackInteraction(e, `${t('match_watch_on')} ${t('appletv')}`)
        }
      >
        <img
          src={`/assets/images/watch-on-appletv-b-${culture}.png`}
          alt={`${t('match_watch_on')} ${t('appletv')}`}
        />
      </a>
    );
  }

  if (hasHighlights && highlightsUrl) {
    return (
      <a
        href={highlightsUrl}
        target='_self'
        className="mls-c-priority-match__cta mls-c-priority-match__cta--highlights"
        onClick={(e) => trackInteraction(e, t('highlights'))}
      >
        {t('highlights')}
      </a>
    );
  }

  if (matchPageUrl) {
    return (
      <a
        href={matchPageUrl}
        target='_self'
        className="mls-c-priority-match__cta mls-c-priority-match__cta--highlights"
        onClick={(e) => trackInteraction(e, t('match_hub'))}
      >
        {t('match_hub')}
      </a>
    );
  }

  return (
    <span className="mls-c-priority-match__separator">
      {' '}
      {status === statusTypes.pre || status === statusTypes.live
        ? t('priority-match-vs')
        : '-'}
    </span>
  );
}

export default MatchCta;
